import { Layout } from "antd";
import { Content } from "antd/lib/layout/layout";

const LoginLayout: React.FC<any> = ({ loginForm }: any) => {
  return (
    <Layout className="login-layout h-100">
      <Layout className="login-layout-inner">
        <Content className="login-layout-content">{loginForm}</Content>
      </Layout>
    </Layout>
  );
};
export default LoginLayout;
